module.exports = __webpack_public_path__ + "img/WP2023-PhotoExhibit.c418cce3.jpg";